import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  styled,
  Switch,
  Drawer,
  Tooltip,
} from "@mui/material";
import { useSelector } from "react-redux";
import DummyImg from "../../../assets/customerAssets/user_D.jpeg";
import notification from "../../../assets/customerAssets/icons/notification.svg";
import changePassword from "../../../assets/customerAssets/icons/changePassword.svg";
import HelpSupport from "../../../assets/customerAssets/icons/helpSupport.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../../context/auth";
import { useNavigate, useParams } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import DeletePNG from "../../../assets/customerAssets/icons/delete.png";
import { deleteAccount } from "../../../api/deleteAccount";
import DeleteModal from "../../Modals/DeleteAccountModal";
import { toast } from "react-toastify";

const CustomTextarea = styled(TextField)((...props) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#121322",
    borderTop: "1px solid #414466",
    borderBottom: "1px solid #414466",
    color: "white",
    borderRadius: "0",
    "&:hover": {
      backgroundColor: "#121322",
    },
    "&.Mui-focused": {
      backgroundColor: "#121322",
      outline: "none",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

const pageNameArray = ["edit-profile", "help-and-support", "change-password"];

const Sidebar = () => {
  const userData = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const urlparam = useParams();
  const [open, setOpen] = useState(false);
  const [openDeleteAccount, setOpenDeleteAccount] = useState(false);

  const deleteAccountCall = useCallback(() => {
    if (!userData?.data?.id) {
      toast.error("No user id found");
    }
    deleteAccount(userData.data.id, token);
    navigate("/Register");
  }, [userData, token]);

  useEffect(() => {
    if (!pageNameArray.includes(urlparam.page)) {
      navigate("/not-found");
    }
  }, urlparam);
  return (
    <>
      <Box className="sidebar-settings desktop-settings">
        <Box className="sidebar-settings-wrapper">
          <Box className="heading">
            <Typography component="h1">Settings</Typography>
          </Box>

          <Button
            className={
              urlparam.page == "edit-profile"
                ? "profile-wrapper active"
                : "profile-wrapper"
            }
            onClick={() => navigate("/settings/edit-profile")}
          >
            <Box className="image">
              <img
                src={userData?.data?.profile_img || DummyImg}
                className="img_fluid"
                style={{
                  objectFit: "cover",
                  border: "4px solid transparent",
                  borderRadius: "50%",
                }}
              />
            </Box>
            <Box className="info">
              <Typography component="h2">
                {userData.data.firstName + " " + userData.data.lastName}
              </Typography>
              <Tooltip title={userData.data.email} placement="top">
                <Typography component="p" sx={{}}>
                  {userData.data.email}
                </Typography>
              </Tooltip>
            </Box>
          </Button>
          <Box className="account-setting">
            <Typography component="h2">Account Settings</Typography>
            <Button
              className={
                urlparam.page == "change-password"
                  ? "setting active"
                  : "setting"
              }
              sx={{ borderTop: "1px solid #414466" }}
              onClick={() => navigate("/settings/change-password")}
            >
              <Box className="setting-wrapper">
                <img src={changePassword} />
                <Typography component="p">Change Password</Typography>
              </Box>
            </Button>
            <Button
              className="setting"
              style={{
                borderBottom: "1px solid #414466",
                borderTop: "1px solid #414466 ",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box className="setting-wrapper">
                <img src={notification} />
                <Typography component="p">Push Notification</Typography>
              </Box>
              <IOSSwitch sx={{ m: 1 }} defaultChecked />
            </Button>
            <Button
              className={
                urlparam.page == "help-and-support"
                  ? "setting active"
                  : "setting"
              }
              sx={{
                borderTop: "1px solid #414466",
                borderBottom: "1px solid #414466",
                marginTop: "20px",
              }}
              onClick={() => navigate("/settings/help-and-support")}
            >
              <Box className="setting-wrapper">
                <img src={HelpSupport} />
                <Typography component="p">Help & Support</Typography>
              </Box>
            </Button>

            <Button
              className={"help-and-support setting "}
              sx={{
                borderTop: "1px solid #414466",
                borderBottom: "1px solid #414466",
                marginTop: "20px",
              }}
              onClick={() => {
                // navigate("/settings/help-and-support");
                // setOpen(false);
                // deleteAccountCall();
                setOpenDeleteAccount(true);
              }}
            >
              <Box className="setting-wrapper">
                <img src={DeletePNG} width={28} height={28} />
                <Typography component="p">Delete Account</Typography>
              </Box>
            </Button>
          </Box>

          <Button className="logout" onClick={() => logout()}>
            Logout <LogoutIcon />
          </Button>
        </Box>
      </Box>

      <Box className="sidebar-settings-mobile">
        <Box className="sidebar-settings-wrapper">
          <IconButton onClick={() => setOpen(true)}>
            <SettingsIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Box>

      <Drawer open={open} onClose={() => setOpen(false)} anchor="left">
        <Box
          className="settings"
          sx={{ width: "272px", height: "100%", overflow: "auto" }}
        >
          <Box className="sidebar-settings">
            <Box className="sidebar-settings-wrapper">
              <Box className="heading">
                <Typography component="h1">Settings</Typography>
              </Box>

              <Button
                className={
                  urlparam.page == "edit-profile"
                    ? "profile-wrapper active"
                    : "profile-wrapper"
                }
                onClick={() => {
                  navigate("/settings/edit-profile");
                  setOpen(false);
                }}
              >
                <Box className="image">
                  <img
                    src={userData?.data?.profile_img || DummyImg}
                    className="img_fluid"
                    style={{
                      objectFit: "cover",
                      border: "4px solid transparent",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
                <Box className="info">
                  <Typography component="h2">
                    {userData.data.firstName + " " + userData.data.lastName}
                  </Typography>
                  <Typography component="p">{userData.data.email}</Typography>
                </Box>
              </Button>
              <Box className="account-setting">
                <Typography component="h2">Account Settings</Typography>
                <Button
                  className={
                    urlparam.page == "change-password"
                      ? "setting active"
                      : "setting"
                  }
                  sx={{ borderTop: "1px solid #414466" }}
                  onClick={() => {
                    navigate("/settings/change-password");
                    setOpen(false);
                  }}
                >
                  <Box className="setting-wrapper">
                    <img src={changePassword} />
                    <Typography component="p">Change Password</Typography>
                  </Box>
                </Button>
                <Button
                  className="setting"
                  style={{
                    borderBottom: "1px solid #414466",
                    borderTop: "1px solid #414466 ",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box className="setting-wrapper">
                    <img src={notification} />
                    <Typography component="p">Push Notification</Typography>
                  </Box>
                  <IOSSwitch sx={{ m: 1 }} defaultChecked />
                </Button>
                <Button
                  className={
                    urlparam.page == "help-and-support"
                      ? "setting active"
                      : "setting"
                  }
                  sx={{
                    borderTop: "1px solid #414466",
                    borderBottom: "1px solid #414466",
                    marginTop: "20px",
                  }}
                  onClick={() => {
                    navigate("/settings/help-and-support");
                    setOpen(false);
                  }}
                >
                  <Box className="setting-wrapper">
                    <img src={HelpSupport} />
                    <Typography component="p">Help & Support</Typography>
                  </Box>
                </Button>

                <Button
                  className={"help-and-support setting "}
                  sx={{
                    borderTop: "1px solid #414466",
                    borderBottom: "1px solid #414466",
                    marginTop: "20px",
                  }}
                  onClick={() => {
                    // navigate("/settings/help-and-support");
                    // setOpen(false);
                    // deleteAccountCall();
                    setOpenDeleteAccount(true);
                  }}
                >
                  <Box className="setting-wrapper">
                    <img src={DeletePNG} width={28} height={28} />
                    <Typography component="p">Delete Account</Typography>
                  </Box>
                </Button>
              </Box>

              <Button className="logout" onClick={() => logout()}>
                Logout <LogoutIcon />
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>

      <DeleteModal
        state={openDeleteAccount}
        setState={setOpenDeleteAccount}
        handlerFunction={deleteAccountCall}
      />
    </>
  );
};

export default Sidebar;
